import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useJob } from '../../contexts/useJobs';
import VacanteCard from "./vacanteCard";
import { isEditMetodo } from '../../../redux/actions/jobsAction';
import unisATSRoutes from '../../../system/router';
import ModalPaused from './modal/modalPaused';
import { deteleVacancy, editPausedPlay } from '../../../redux/actions/vacanciesActions';
import Paginations from './Pagination';

const Card = (props) => {
  const refVacantes = React.useRef();
  const claims = useSelector((state) => state.auth.claims);
  const companyData = useSelector((state) => state.company);
  const jobFinal = useSelector((state) => state.jobs?.jobsView || []);
  const Jobs = useSelector((state) => state.vacancies);
  const dispatch = useDispatch();
  const [modalPuased, setModalPaused] = React.useState(false);
  const { onRemovePermanent, triggered, Job } = props;
  const { pagination, state, text } = useJob();
  // const [jobFinal, setJobFinal] = React.useState([]);
  const history = useHistory();

  // React.useEffect(() => {
  //   console.log(state.jobs)
  //   setJobFinal(state.jobs || []);
  // }, [state.jobs]);
  const edit = async (jobID) => {
    const info = Jobs.find((job) => job.jobID === jobID);
    dispatch(isEditMetodo(info));
    history.push(unisATSRoutes.FORMVACANCYADD);
  };
  const toogleModalPaused = (jobID) => {
    const info = Jobs.find((job) => job.jobID === jobID);
    dispatch(isEditMetodo(info));
    setModalPaused(!modalPuased);
  };
  const onPlay = (jobID) => {
    dispatch(editPausedPlay(jobID));
  };
  const onRemove = (jobID) => {
    dispatch(deteleVacancy(jobID));
  };
  const changedPage = () => {
    refVacantes.current.scrollTo(0, 0);
  };
  return (
    <div className="row-view" ref={refVacantes}>
      {modalPuased ? <ModalPaused close={toogleModalPaused} /> : null}

      {jobFinal.slice(pagination * 10 - 10, pagination * 10).map((job) => {
        if (claims?.typeuser !== 'usuario') {
          return (
            <VacanteCard
              key={job.jobID}
              {...job}
              claims={claims}
              triggered={triggered}
              name={companyData.companyName.toUpperCase()}
              onRemovePermanent={onRemovePermanent}
              edit={edit}
              onPause={toogleModalPaused}
              onPlay={() => onPlay(job.jobID)}
            />
          );
        }
        if (job?.select_users ? job?.select_users.filter((e) => e.objectID === claims?.user_id).length > 0 : false) {
          return (
            <VacanteCard
              key={job?.jobID}
              {...job}
              claims={claims}
              triggered={triggered}
              name={companyData?.companyName.toUpperCase()}
              onRemovePermanent={onRemovePermanent}
              edit={edit}
              onPause={toogleModalPaused}
              onPlay={() => onPlay(job.jobID)}
            />
          );
        }
        if (job?.encargado ? job?.encargado.filter((e) => e.objectID === claims?.user_id).length > 0 : false) {
          return (
            <VacanteCard
              key={job.jobID}
              {...job}
              claims={claims}
              triggered={triggered}
              name={companyData.companyName.toUpperCase()}
              onRemovePermanent={onRemovePermanent}
              edit={edit}
              onPause={toogleModalPaused}
              onPlay={() => onPlay(job.jobID)}
            />
          );
        }
        return null;
      })}
      <Paginations searchQuery={text} filtros={state.filtros} jobs={state.jobs} Job={Job} changedPage={changedPage} />
    </div>
  );
};

Card.propTypes = {
  onRemovePermanent: PropTypes.func,
  triggered: PropTypes.bool,
};

Card.defaultProps = {
  onRemovePermanent: () => {},
  triggered: false,
};

export default Card;
